import UserReport from "./UserReport";

export default UserReport;